<template>
  <div v-loading.fullscreen.lock="fullscreenLoading">
    <el-form size="small" :inline="true" :model="params" class="demo-form-inline">
      <el-form-item label="关键字">
        <el-input v-model="params.Keyword" placeholder="提货单号、车牌号、身份证"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
      </el-form-item>
    </el-form>
    <paging :url="url.list" :params="params" ref="paging" style="width: 990px;">
      <el-table border slot-scope="grid" :data="grid.data" style="width: 100%" v-loading="grid.loading || loading">
        <el-table-column align="center" prop="CreateTime" label="添加日期" width="180">
          <template slot-scope="scope">
            <div>{{ scope.row.CreateTime | dateNoT }}</div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="Id" label="编号" width="180"></el-table-column>
        <el-table-column align="center" label="预提量/提货量" width="120">
          <template slot-scope="scope">
            {{
              scope.row.LadingAmount ? scope.row.LadingAmount : 0
            }}/{{ scope.row.DeliverAmount ? scope.row.DeliverAmount : 0 }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="Status" label="状态" width="120">
          <template slot-scope="scope">
            <el-tag type="default" v-if="scope.row.Status == 1" size="medium">待提货</el-tag>
            <el-tag type="success" v-else-if="scope.row.Status == 16" size="medium">已支付</el-tag>
            <el-tag type="default" v-else-if="scope.row.Status == 2" size="medium">已制卡</el-tag>
            <el-tag type="default" v-else-if="scope.row.Status == 3" size="medium">已叫号</el-tag>
            <el-tag type="default" v-else-if="scope.row.Status == 4" size="medium">已进场</el-tag>
            <el-tag type="default" v-else-if="scope.row.Status == 5" size="medium">叫号超时</el-tag>
            <el-tag type="default" v-else-if="scope.row.Status == 6" size="medium">过皮重</el-tag>
            <el-tag type="default" v-else-if="scope.row.Status == 7" size="medium">正在装车</el-tag>
            <el-tag type="default" v-else-if="scope.row.Status == 8" size="medium">装车结束</el-tag>
            <el-tag type="default" v-else-if="scope.row.Status == 9" size="medium">过毛重</el-tag>
            <el-tag type="success" v-else-if="scope.row.Status == 10" size="medium">已结算</el-tag>
            <el-tag type="success" v-else-if="scope.row.Status == 11" size="medium">已出场</el-tag>
            <el-tag type="info" v-else-if="scope.row.Status == 12" size="medium">已作废</el-tag>
            <el-tag type="default" v-else-if="scope.row.Status == 13" size="medium">正在计算含水</el-tag>
            <el-tag type="info" v-else-if="scope.row.Status == 14" size="medium">请求制卡</el-tag>
            <el-tag type="default" v-else-if="scope.row.Status == 15" size="medium">制卡失败</el-tag>
            <el-tag type="info" v-else-if="scope.row.Status == -2" size="medium">超时</el-tag>
            <el-tag type="info" v-else-if="scope.row.Status == -12" size="medium">作废中</el-tag>
            <!--<el-tag type="info" v-else-if="scope.row.Status == 0 && orderStatus== 0" size="medium">待支付</el-tag>-->
            <el-tag type="info" v-else-if="scope.row.Status == 0" size="medium">待生效</el-tag>
            <el-tag type="info" v-else-if="scope.row.Status == -1" size="medium">上传中</el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="CarNumber" label="车牌号" width="120"></el-table-column>
        <el-table-column align="center" prop="DriverIDCard" label="身份证号"
                         :show-overflow-tooltip="true"></el-table-column>
        <el-table-column align="center" prop="DriverName" label="司机" width="100"></el-table-column>
        <el-table-column align="center" prop="DriverPhone" label="手机号" width="140"
                         :show-overflow-tooltip="true"></el-table-column>


        <el-table-column fixed="right" label="操作" width="250" header-align="center" align="center">
          <template slot-scope="scope">
            <el-button @click="updata(scope.row)" type="text" size="small"
                       v-if="scope.row.Status==0">上传
            </el-button>
            <el-button @click="onEdit(scope.row)" type="text" size="small"
                       v-if="scope.row.Status==0 || scope.row.Status==1||scope.row.Status==16||scope.row.Status==-9">编辑
            </el-button>
            <el-button @click="onDelete(scope.row)"
                       v-if="scope.row.Status==1||scope.row.Status==16||scope.row.Status==-9||scope.row.Status==15||scope.row.Status==0"
                       type="text" size="small">作废
            </el-button>
            <el-button @click="onzz(scope.row)" type="text" size="small">提货单详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </paging>

    <!--修改弹框-->
    <dialog-form title="修改提货单"
                 :formTemplate="formTemplate"
                 :visible.sync="visible"
                 :form="form" :rules="rules"
                 :url="url.save"
                 :isEdit="isEdit"
                 @saved="editSave()">
    </dialog-form>
    <el-dialog center title="提货单详情" :visible.sync="orderDialog">
      <div class="form-group-title"><span class="ogc-icon-font ogc-icon-salefill"></span>提货单信息</div>
      <el-form ref="Ladingform" :model="Ladingform" label-width="80px">
        <el-col :span="12">
          <el-form-item>
            提货单状态：{{ Ladingform.StatusStr }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item>
            提货单号：{{ Ladingform.Id }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item>
            SAP提货单号：{{ Ladingform.SAPLading }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item>
            订单号：{{ Ladingform.OrderNo }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item>
            提货数量：{{ Ladingform.LadingAmount }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item>
            实际提货量：{{ Ladingform.DeliverAmount }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item>
            创建时间：{{ Ladingform.CreateTime | dateNoT }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item>
            提货时间：{{ Ladingform.DeliverTime |dateNoT }}
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item>
            毛重：{{ Ladingform.GrossWeigth}}
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item>
            皮重：{{ Ladingform.TruckWeigth}}
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item>
            净重：{{ Ladingform.DeliverAmount }}
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item>
            备注：{{ Ladingform.CancelRemark }}
          </el-form-item>
        </el-col>
      </el-form>
      <div class="form-group-title"><span class="ogc-icon-font ogc-icon-salefill"></span>司机信息</div>
      <el-form ref="Ladingform" :model="Ladingform" label-width="80px">
        <el-col :span="12">
          <el-form-item>
            司机名称：{{ Ladingform.DriverName }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item>
            车牌号：{{ Ladingform.CarNumber }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item>
            身份证号：{{ Ladingform.DriverIDCard }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item>
            手机号：{{ Ladingform.DriverPhone }}
          </el-form-item>
        </el-col>
      </el-form>

      <el-table border :data="orderCatch">
        <el-table-column label="状态" header-align="center" align="center">
          <template slot-scope="scope">
            <span type="default" v-if="scope.row.Status == 1" size="medium">待提货</span>
            <span type="success" v-else-if="scope.row.Status == 16" size="medium">已支付</span>
            <span type="default" v-else-if="scope.row.Status == 2" size="medium">已制卡</span>
            <span type="default" v-else-if="scope.row.Status == 3" size="medium">已叫号</span>
            <span type="default" v-else-if="scope.row.Status == 4" size="medium">已进场</span>
            <span type="default" v-else-if="scope.row.Status == 5" size="medium">叫号超时</span>
            <span type="default" v-else-if="scope.row.Status == 6" size="medium">过皮重</span>
            <span type="default" v-else-if="scope.row.Status == 7" size="medium">正在装车</span>
            <span type="default" v-else-if="scope.row.Status == 8" size="medium">装车结束</span>
            <span type="default" v-else-if="scope.row.Status == 9" size="medium">过毛重</span>
            <span type="success" v-else-if="scope.row.Status == 10" size="medium">已结算</span>
            <span type="success" v-else-if="scope.row.Status == 11" size="medium">已完成</span>
            <span type="info" v-else-if="scope.row.Status == 12" size="medium">已作废</span>
            <span type="default" v-else-if="scope.row.Status == 13" size="medium">正在计算含水</span>
            <span type="info" v-else-if="scope.row.Status == 14" size="medium">请求制卡</span>
            <span type="default" v-else-if="scope.row.Status == 15" size="medium">制卡失败</span>
            <span type="info" v-else-if="scope.row.Status == -2" size="medium">超时</span>
            <span type="info" v-else-if="scope.row.Status == -12" size="medium">作废中</span>
            <span type="info" v-else size="medium">创建、上传提货单信息</span>
          </template>
        </el-table-column>
        <el-table-column prop="CreateTime" label="创建时间" header-align="center" align="center">
          <template slot-scope="scope">
            <div>{{ scope.row.CreateTime | dateNoT }}</div>
          </template>
<!--          <el-table-column align="center" prop="Weight" label="备注" width="220">-->
<!--          </el-table-column>-->
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="orderDialog = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/javascript">
import Paging from '@/components/Table/Paging'
import DialogForm from '@/components/Dialogs/DialogForm';

export default {
  components: {
    Paging, DialogForm
  },
  props: {
    screen: {
      type: Object,
      default: () => {
      }
    },
    id: {
      type: String,
      default: null
    },
    ProductId: {
      type: String,
      default: null
    },
    isEdit: {
      type: Boolean,
      default: true,
    },
    orderStatus: {
      type: Number,
    }
  },
  data() {
    let validateCarNo = (rule, value, callback) => {
      let regex = /(^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领台A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1}$)/;
      if (value != null && !regex.test(value)) {
        callback(new Error('请输入正确的车牌号'));
      } else {
        callback();
      }
    }
    return {
      url: {
        list: SZH.assets.api + '/Order/GetPagingBillForWeb',
        save: SZH.assets.api + '/Order/ModifyBillInfo',
        delete: SZH.assets.api + '/Order/TovoidBill',
        updateUrl: SZH.assets.api + '/Order/ManualCreateBill',
        GetBill: SZH.assets.api + '/Order/GetBill',
        GetAppointmentInfo: SZH.assets.api + '/Custom/GetAppointmentInfo',
        SaveAppointmentLadingInfo: SZH.assets.api + '/Custom/SaveAppointmentLadingInfo',
        CancelAppointmentLading: SZH.assets.api + '/Custom/CancelAppointmentLading',
        CheckModifyBillInfo: SZH.assets.api + '/Order/CheckModifyBillInfo',
        SelectItems: SZH.assets.api + '/ItemType/SelectItems',
      },
      loading: false,
      fullscreenLoading: false,
      AppointmentDialog: false,
      radioId: '',
      NeededId: '',
      TimeStr: '',
      ProductGroupId: '',
      NeedOrderId: '',
      params: {
        OrderId: '', // 关键字
        Keyword:''
      },
      data: [],
      tableData: [],
      visible: false,
      Ladingform: {},
      form: {
        billId: '',
        LadingAmount: '',
        CarNumber: '',
        DriverName: '',
        DriverIDCard: '',
        DriverPhone: '',
        TruckWeigthPlan:'',
        CanNo:'',
        ModificationContent:''
      },
      formTemplate: [
        {col: 12, label: '设定提货量', prop: 'LadingAmount'},
        {col: 12, label: '预计皮重', prop: 'TruckWeigthPlan'},
        {col: 12, label: '车牌号', prop: 'CarNumber'},
        {col: 12, label: '挂车号', prop: 'CanNo'},
        {col: 12, label: '改装内容', prop: 'ModificationContent',type:'select',options: []},
        {col: 12, label: '司机名称', prop: 'DriverName'},
        {col: 12, label: '司机身份证号', prop: 'DriverIDCard'},
        {col: 12, label: '司机手机号', prop: 'DriverPhone'},
      ],
      rules: {
        LadingAmount: [
          {required: true, message: '请输入设定提货量', trigger: 'blur'},
          {
            validator: (rule, value, callback) => {
              var reg = /^[0-9]+([.]{1}[0-9]{1,3})?$/;
              if (!reg.test(value)) {
                callback(new Error('请输入数字最多精确到后三位'));
              } else {
                callback();
              }
            },
            trigger: 'change',
          },
        ],
        TruckWeigthPlan: [
          {required: true, message: '请输入预计皮重', trigger: 'blur'},
          {
            validator: (rule, value, callback) => {
              var reg = /^[0-9]+([.]{1}[0-9]{1,3})?$/;
              if (!reg.test(value)) {
                callback(new Error('请输入数字最多精确到后三位'));
              } else {
                callback();
              }
            },
            trigger: 'change',
          },
        ],
        CarNumber: [
          {required: true, message: '请输入车牌号', trigger: 'blur'},
          {validator: validateCarNo, trigger: 'blur'}
          // { min: 5, max: 10, message: '车牌号长度应在 5 到 10 个字符之间', trigger: 'blur' }
        ],
        CanNo: [
          {required: true, message: '请输入挂车号', trigger: 'blur'},
          // {validator: validateCarNo, trigger: 'blur'}
          // { min: 5, max: 10, message: '车牌号长度应在 5 到 10 个字符之间', trigger: 'blur' }
        ],
        ModificationContent:[
          { required: true,  message: '请选择改装内容', trigger: 'change' }
        ],
        DriverIDCard: [
          {required: true, message: '请输入证件号码', trigger: 'blur'}, {validator: validateIdCard, trigger: 'blur'}
        ],
        DriverPhone: [
          /*{ required: true, message: '请输入手机号', trigger: 'blur' },*/ {validator: validatePhone, trigger: 'blur'}
        ]
      },
      orderDialog: false,
      orderCatch: [],
      selectItemArr:[]
    }
  },
  methods: {
    loadSelect(){
      var self = this;
      self.$http.post(self.url.SelectItems, {
        keyValue:"ModificationContent"
      }).then(result => {
        if (result.state == true && result.data && result.data.length > 0) {
          self.selectItemArr = result.data;
          for(let i in self.formTemplate){
            if(self.formTemplate[i].prop == "ModificationContent"){
              self.formTemplate[i].options = self.selectItemArr
            }
          }
        } else {
          self.selectItemArr = [];
        }
        self.loading = false;
      }, () => {
        self.loading = false;
      });
    },
    onSearch(){
      this.$refs['paging'].reload();
    },
    reload() {
      this.$refs['paging'].reload();
    },
    onEdit(row) {
      this.visible = true;
      setTimeout(() => {
        for (var i in this.form) {
          if (row[i] !== undefined) {
            this.form[i] = row[i];
          }
        }
        this.form.billId = row.Id;
      }, 700)
    },
    updata(row) {
      this.$confirm('确定上传吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.fullscreenLoading = true;
        this.$http.post(this.url.updateUrl, {
          keyValue: row.Id
        }).then(result => {
          if (result.state == true) {
            this.$refs['paging'].loadData();
            this.$message.success('上传成功！');
          } else {
            this.$message.error(result.message);
          }
          this.fullscreenLoading = false;
        }, () => {
          this.fullscreenLoading = false;
          this.$message.error('数据上传失败，请检查您的网络是否可用。');
        });

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消上传'
        });
      });
    },
    // 保存
    editSave() {
      this.$message.success('保存成功');
      this.visible = false;
      this.$refs['paging'].loadData();
    },
    onDelete(row) {
      var self = this;
      self.$confirm('将永久作废, 是否继续?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        self.loading = true;
        self.$http.post(self.url.delete, {
          KeyValue: row.Id
        }).then(result => {
          if (result.state == true) {
            self.$refs['paging'].loadData();
            self.$emit('deleted');
            self.$message.success('作废成功！');
          } else {
            self.$message.error(result.message);
          }
          self.loading = false;
        }, () => {
          self.loading = false;
          self.$message.error('数据作废失败，请检查您的网络是否可用。');
        });
      }).catch(() => {
        self.$message({
          type: 'info',
          message: '已取消作废操作'
        });
      });
    },
    onzz(row) {
      let self = this;
      self.orderDialog = true;
      self.$http.post(self.url.GetBill, {
        keyValue: row.Id
      }).then(result => {
        if (result.state == true && result.data.OrderLadingChange.length > 0) {
          self.Ladingform = result.data
          self.orderCatch = result.data.OrderLadingChange;
        } else {
          self.Ladingform = result.data
          self.orderCatch = [];
        }
      }, () => {
      });
    },
    rowClick(row) {
      // console.log(row)
      this.radioId = row.Id
      this.NeededId = row.Id;
      this.TimeStr = row.F_TimeIntervalStr
      this.ProductGroupId = row.ProductGroupId
      // console.log(this.TimeStr)
      // console.log(this.radioId, '111')
    },
  },
  computed: {},
  created() {

  },
  mounted() {
    this.loadSelect()
    if (this.id != null) {
      this.params.OrderId = this.id;
    }
  },
  watch: {
    isEdit(val) {
      for (var i in this.formTemplate) {
        if (this.formTemplate[i].prop == 'LadingAmount') {
          if (val) {
            this.formTemplate[i].cannotEidt = true;
          } else {
            this.formTemplate[i].cannotEidt = false;
          }
        }
      }
    }
  }
}
</script>

<style type="text/css" scoped>

</style>



// WEBPACK FOOTER //
// src/views/Me/OrderLading/OrderLading.vue